import Vue from 'vue';
import config from '../../config/index';

export default {
  // 查询列表
  getAppVersionList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/appVersion/list`, { params });
  },
  // 新增app 
  postNewApp(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/appVersion/addItem`, params);
  },
  // 编辑app
  postEditAPP(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/appVersion/editItem`, params);
  },
  // 删除app
  postDeleteApp(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/appVersion/delete`, params);
  }
}